import styled, { from } from 'theme';

export const ApplicationWrapper = styled.div`
  .application-card {
    margin-bottom: 2rem;
  }

  .how-to-test__button {
    white-space: nowrap;

    ${from('md')} {
      margin-top: -0.5rem;
    }
  }
`;

export const DeleteModalWrapper = styled.div`
  .modal__body {
    .modal__body-text {
      padding: 2rem 0;
    }
  }

  .application-remove-form__submit {
    background-color: ${props => props.theme.variables.colors.red};
    &:hover {
      background-color: ${props => props.theme.variables.colors.darkRed};
    }
  }
`;
